import React from "react";
import ReactDOM from "react-dom";
import "mobx-react-lite/batchingForReactDom";

import App from "./App";
import reportWebVitals from "./reportWebVitals";

import AuthProvider from "stores/auth";
import LoadingPage from "routes/LoadingPage";

import "./i18n";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";

library.add(fas, far, fab);

ReactDOM.render(
  <AuthProvider>
    <React.Suspense fallback={<LoadingPage />}>
      <App />
    </React.Suspense>
  </AuthProvider>,
  document.getElementById("root"),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
